export default "__VITE_ASSET__Nv$SbuYB__"